import React, { useEffect } from 'react';
import styled from 'styled-components';

type DividerComponentProps = {
  level: 'success' | 'error'
  message: string
}

const FlashStyle = styled.div<{$level: 'success' | 'error'}>`
  position: fixed;
  border-radius: 4px;
  font-size: 14px;
  line-height: 17px;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  bottom: 0;
  right: 0;
  min-width: 200px;
  margin: 0 20px 20px 0;
  padding: 10px;
  z-index: 1;

  ${props => {
    switch (props.$level) {
      case 'success':
        return `
          background: #d1e7dd;
          border: 1px solid #badbcc;
          color: #0f5132;
      `;
      case 'error':
        return `
          background: #f8d7da;
          border: 1px solid #f5c2c7;
          color: #842029;
      `;
    }
  }}
  
  &.hidden {
    opacity: 0;
  }
  
  button {
    float: right;
    background: none;
    border: none;
  }
`;

const Flash: React.FC<DividerComponentProps> = ({ message, level }) => {
  const [ show, setShow ] = React.useState<boolean>(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShow(false);
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  const onClickCloseButton = () => {
    setShow(false);
  };

  return (
    <FlashStyle className={show ? '' : 'hidden'} $level={level}>
      { message }
      <button onClick={onClickCloseButton}>x</button>
    </FlashStyle>
  );
};

export default Flash;
